module.exports = __webpack_public_path__ + "static/media/download.e8ba16c3.svg";